'use client';

/**
 * Next.js Global Error Boundary
 *
 * This is the last line of defense for critical application errors:
 * - Errors in the root layout.tsx
 * - Errors that crash the entire application
 * - Errors not caught by route-level error.tsx boundaries
 * - Critical system failures that affect the whole app
 *
 * Key differences from error.tsx:
 * - Must include full HTML structure (html, body tags)
 * - Only catches errors that would otherwise crash the entire app
 * - Used as a fallback when route-level error boundaries fail
 * - Shows a more critical error message to indicate system-wide failure
 *
 * When an error occurs, this component:
 * 1. Reports the critical error to PostHog with global error context
 * 2. Shows a critical error page indicating system-wide failure
 * 3. Provides recovery options (try again/reload)
 * 4. Uses a different visual design to indicate severity
 *
 * This file should only be placed in the app root directory.
 */

import ErrorFallback from '@/lib/posthog/ErrorFallback';
import { PageErrorProps } from './error';

const PageGlobalError = ({ error, reset }: PageErrorProps) => {
  return <ErrorFallback error={error} resetErrorBoundary={reset} />;
};

export default PageGlobalError;
